import { useCallback } from "react";
import { Helmet } from "react-helmet";
import bm from "../100-board-members/BoardMembers100.module.scss";
import Styles from "./VisionMission.module.scss";
import { FaCheckCircle, FaCompass, FaRocket } from "react-icons/fa";

const visionBullets = [
  "Our Vision is to see a world of real equality where each person gets an opportunity to excel!",
  "We work collaboratively, with an obsession to make a profound impact on individuals and each other.",
  "We honour authenticity, ownership, and rigor, making a difference with excellence towards impact.",
  "Every customer deeply impacted is as important as the profit we make.",
  "We actively seek partners, talent, and collaboration towards our mission, keeping an open mind to working with others.",
  "Together, let's shape a world where Women Leaders not only succeed but thrive, rewriting the narrative for a new generation of leaders.",
];

export default function VisionMission() {
  const scrollToPurpose = useCallback(() => {
    document
      .getElementById("purpose-content")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className={bm["page-wrapper"]}>
      <Helmet>
        <title>Purpose &amp; Vision | Iron Lady</title>
        <meta
          name="description"
          content="Iron Lady exists to enable a million women to reach the top—and to build a world of real equality. Read our purpose and vision."
        />
        <link rel="canonical" href="https://iamironlady.com/aboutUs/purpose-and-vision" />
      </Helmet>

      <section className={`${bm.hero} ${Styles.pvHero}`} aria-labelledby="pv-hero-heading">
        <div className={bm["hero-overlay"]} aria-hidden />
        <div className={bm["hero-inner"]}>
          <div className={bm["hero-content"]}>
            <div className={bm["hero-eyebrow"]}>About</div>
            <div className={bm["hero-brand"]}>Iron Lady</div>
            <h1
              id="pv-hero-heading"
              className={`${bm["hero-tagline"]} ${Styles.pvHeroHeadline}`}
            >
              <span className={Styles.pvHeroInner}>
                <FaCompass className={Styles.pvHeroIcon} aria-hidden />
                <span className={Styles.pvHeroWords}>
                  <span className={Styles.pvHeroPlain}>Purpose </span>
                  <span className={Styles.pvHeroAccent}>&amp; vision.</span>
                </span>
              </span>
            </h1>
            <p className={bm["hero-sub"]}>
              Why we exist, how we show up every day, and the future we&apos;re building with partners,
              talent, and women leaders everywhere.
            </p>
            <div className={`${bm["hero-cta"]} ${bm["hero-cta-group"]}`}>
              <button type="button" className={bm["btn-primary"]} onClick={scrollToPurpose}>
                <span>Read purpose &amp; vision</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section
        id="purpose-content"
        className={`${Styles.pvSection} ${Styles.purposeBand}`}
        aria-labelledby="purpose-heading"
      >
        <div className={Styles.pageInner}>
          <span className={Styles.sectionEyebrow}>Why we exist</span>
          <h2 id="purpose-heading" className={Styles.panelTitle}>
            Our purpose
          </h2>
          <div className={Styles.glassPanel}>
            <div className={Styles.purposeItem}>
              <FaRocket className={Styles.purposeIcon} aria-hidden />
              <p className={Styles.purposeText}>
                Our Purpose is to enable a million women to reach the TOP.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`${Styles.pvSection} ${Styles.visionBand}`}
        aria-labelledby="vision-heading"
      >
        <div className={Styles.pageInner}>
          <span className={Styles.sectionEyebrow}>How we operate</span>
          <h2 id="vision-heading" className={Styles.panelTitle}>
            Our vision
          </h2>
          <div className={Styles.glassPanel}>
            <ul className={Styles.visionList}>
              {visionBullets.map((text) => (
                <li key={text} className={Styles.visionItem}>
                  <FaCheckCircle className={Styles.checkIcon} aria-hidden />
                  <p className={Styles.visionText}>{text}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
